<template>
    <div>
        <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

        <div v-if="(!errors && !loading && (items.length == 0))" class="alert alert-warning" role="alert">
            {{ $root.text('There are no homepage pop-ups that match your selection', null, true) }}
        </div>

        <div v-if="(items.length > 0)" class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-centered table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    <div class="row">
                                        <div class="col-lg-11 col-10">{{ $root.text('Title', null, true) }}</div>
                                        <div class="col-lg-1 col-2">&nbsp;</div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td scope="row" :id="'popup-row' + item.id" class="pb-0">
                                    <div class="row">
                                        <div class="col-sm-10 col-9" style="padding-top: 3px">
                                            <h5 class="font-size-14 mb-0">
                                                <a href="#" class="text-dark" @click.prevent="toggleEditPopup(item)">
                                                    {{ item.title || $root.text('(no title)', null, true) }}
                                                </a>
                                            </h5>
                                        </div>
                                        <div class="col-sm-2 col-3 font-size-18 contact-links">
                                            <a
                                                href="#"
                                                class="float-right ml-2"
                                                @click.prevent="toggleEditPopup(item)"
                                            >
                                                <span
                                                    v-if="(popup_details_open.indexOf(item.id) < 0)"
                                                    :key="'close-' + item.id"
                                                >
                                                    <i class="fa-regular fa-chevron-circle-down"></i>
                                                </span>
                                                <span v-else :key="'open-' + item.id">
                                                    <i class="fa-regular fa-chevron-circle-up"></i>
                                                </span>
                                            </a>
                                            <a
                                                href="#"
                                                class="float-right"
                                                data-toggle="modal"
                                                data-target="#home-popup-modal"
                                                @click.prevent="resetHomePopup(item)"
                                                v-b-tooltip.hover.left
                                                :title="$root.text('Preview pop-up', null, true)"
                                            >
                                                <i class="fa-regular fa-eye"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="row list-details-td mt-2">
                                        <div class="col-12 list-details" :id="'popup-details' + item.id">
                                            <home-popup-edit-form
                                                v-if="popup_details_open.indexOf(item.id) > -1"
                                                :data="item"
                                                :user_groups="user_groups"
                                            ></home-popup-edit-form>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div style="position: relative; top: -20px; height: 40px; overflow: visible">
            <loading v-if="loading"></loading>
        </div>

        <div
            class="modal fade"
            id="home-popup-add-form-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="home-popup-add-form-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
                <home-popup-add-form></home-popup-add-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                component_name: 'home-popups',
                loading: false,
                errors: false,
                roles: [],
                items: [],
                popup_details_open: [],
                user_groups: []
            }
        },
        mounted () {
            $('body').removeClass('login-body');
            this.getPopups();
            this.getUserGroups();
        },
        methods: {
            getPopups: function () {
                if (!this.$root.hasPermission('manage_homepage_popups')) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                    return false;
                }
                this.loading = true;
                this.errors = false;
                this.items = [];
                this.popup_details_open = [];

                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/homepage-popups/'
                    + 'ug::' + this.$root.edit_homepage_user_group;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.items = response.data.popups;
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response.status == 401) {
                        // Missing/lost API token - logout user.
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = error.response.data.error;
                    }
                })
                .finally(() => {
                    vm.loading = false;
                });
            },
            toggleEditPopup: function (popup) {
                if (this.popup_details_open.indexOf(popup.id) < 0) {
                    this.popup_details_open.push(popup.id);
                    $('#popup-row' + popup.id).addClass('highlighted');
                    $('#popup-details' + popup.id).slideDown('slow');
                } else {
                    var vm = this;
                    $('#popup-details' + popup.id).slideUp('slow', function () {
                        $('#popup-row' + popup.id).removeClass('highlighted');
                        for (var n = 0; n < vm.popup_details_open.length; n++) { 
                            if (vm.popup_details_open[n] == popup.id) { 
                                vm.popup_details_open.splice(n, 1); 
                            }
                        }
                    });
                }
            },
            resetHomePopup: function (popup) {
                const appComponent = this.$root.findComponent(this.$root, 'main-app');
                const component = this.$root.findComponent(appComponent, 'home-popup');
                if (component) {
                    component.reset(popup, true);
                }
            },
            getUserGroups: function () {
                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/user-groups/!private';
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.user_groups = response.data.user_groups;
                })
                .catch(function (error) {
                    // Do anything?
                });
            }
        }
    }
</script>
